import React, {
    useContext,
    useEffect,
    useRef,
    useState,
    useCallback,
} from "react";

import "./Timeline.css";

import { SidebarContext } from "../../../context/Sidebar";

import {
    Badge,
    Card,
    Col,
    Row,
    Spinner,
    Alert,
    Button,
} from "react-bootstrap";

import PageLayout from "../../../layouts/PageLayout";

import { useParams } from "react-router-dom";

import axios from "axios";


// ============================================================
// ICONS
// ============================================================

const Icons = {

    office: (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <path d="M3 21h18M3 10h18M5 6l7-3 7 3M5 10v11M19 10v11M9 14h2v2H9zM13 14h2v2h-2z" />
        </svg>
    ),

    award: (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <path d="M12 15l-3.5 2 1.3-4.5-3.8-2.8h4.7L12 5l1.3 4.7h4.7l-3.8 2.8 1.3 4.5z" />
            <path d="M12 22v-7" />
        </svg>
    ),

    meetup: (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <circle
                cx="12"
                cy="8"
                r="4"
            />

            <path d="M5.3 18.3C6.8 16.5 9.2 15 12 15s5.2 1.5 6.7 3.3" />

            <path d="M21 12c0 5-4 9-9 9s-9-4-9-9 4-9 9-9 9 4 9 9z" />
        </svg>
    ),

    people: (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />

            <circle
                cx="9"
                cy="7"
                r="4"
            />

            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />

            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
    ),

    photoshoot: (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <rect
                x="2"
                y="6"
                width="20"
                height="14"
                rx="2"
            />

            <circle
                cx="12"
                cy="13"
                r="3"
            />

            <path d="M8 6l2-3h4l2 3" />
        </svg>
    ),

};


// ============================================================
// DUMMY PRODUCT
// ============================================================

const DUMMY_PRODUCT = {

    id: 14,

    product_code:
        "PRD-000014",

    title:
        "Update online",

    short_description:
        "shoty",

    product_condition:
        "used",

    first_img:
        "products/RciLScUH36OuUT8BK5FRKyEerDOl1rPkwjOsqfmZ.jpg",

    card_img:
        "products/card-images/rFBPEP5zEBqek113SQHmN16UEwsLWDZr6mGtknCL.jpg",

    images: [
        {
            image:
                "products/whB5nHK7bLrZcFX9xZBAxZDbYs9rnNZIbxtmTj1C.jpg",
        },

        {
            image:
                "products/XjEYPV0DnezpvClyp7bxKSK9MngrHAUWMch8A3vc.png",
        },
    ],

    brand:
        "Longines",

    issuer:
        "Administrator",

    lister:
        "Lister User",

    checker:
        null,
};


// ============================================================
// DUMMY TIMELINE
// ============================================================

const DUMMY_TIMELINE = [

    {
        event:
            "Product Created",

        date:
            "12-08-2026 03:07 PM",

        image:
            "products/RciLScUH36OuUT8BK5FRKyEerDOl1rPkwjOsqfmZ.jpg",
    },

    {
        event:
            "Assigned to Lister",

        date:
            "12-08-2026 05:18 PM",

        image:
            "/storage/handover_images/LvP5PUB4iipMKNYVXNJeQbE0m7CvRGsB8wBhwdtr.jpg",
    },

    {
        event:
            "Assigned to Checker",

        date:
            "12-08-2026 09:05 PM",

        image:
            "/storage/handover_images/tSfaLlJOgvdZnxWklxkTZ08t3tRL8DCbcMtcKZU4.jpg",
    },

    {
        event:
            "Checker Received Products",

        date:
            "13-08-2026 12:48 AM",

        image:
            null,
    },

    {
        event:
            "Live on Web",

        date:
            "13-08-2026 01:01 AM",

        image:
            "/storage/handover_images/22SiWCabWCnjeNLjssc3lgpG1QCmUxFdlvvzV0hf.jpg",
    },

    {
        event:
            "Assigned to Stock Keeper",

        date:
            "13-08-2026 01:01 AM",

        image:
            "/storage/handover_images/22SiWCabWCnjeNLjssc3lgpG1QCmUxFdlvvzV0hf.jpg",
    },

];


// ============================================================
// API MODE
// ============================================================

// false = dummy data
// true  = API data

const USE_API = true;


// ============================================================
// API URL
// ============================================================

const API_URL =
    process.env.REACT_APP_API_URL;


// ============================================================
// IMAGE URL
// ============================================================

const getImageUrl = (image) => {

    if (!image) {
        return null;
    }

    return `${process.env.REACT_APP_IMG_URL}${image}`;

};


// ============================================================
// EVENT ICON
// ============================================================

const getEventIcon = (event) => {

    if (!event) {
        return Icons.meetup;
    }


    const value =
        event.toLowerCase();


    if (
        value.includes("created") ||
        value.includes("issued")
    ) {
        return Icons.office;
    }


    if (
        value.includes("lister")
    ) {
        return Icons.people;
    }


    if (
        value.includes("checker")
    ) {
        return Icons.award;
    }


    if (
        value.includes("stock")
    ) {
        return Icons.people;
    }


    if (
        value.includes("live") ||
        value.includes("web")
    ) {
        return Icons.award;
    }


    return Icons.meetup;

};


// ============================================================
// EVENT CATEGORY
// ============================================================

const getEventCategory = (event) => {

    if (!event) {
        return "Movement";
    }


    const value =
        event.toLowerCase();


    if (
        value.includes("created") ||
        value.includes("issued")
    ) {
        return "Product";
    }


    if (
        value.includes("lister")
    ) {
        return "Lister";
    }


    if (
        value.includes("checker")
    ) {
        return "Checker";
    }


    if (
        value.includes("stock")
    ) {
        return "Stock";
    }


    if (
        value.includes("live") ||
        value.includes("web")
    ) {
        return "Website";
    }


    return "Movement";

};


// ============================================================
// COMPONENT
// ============================================================

const Timeline = () => {


    // ========================================================
    // URL ID
    // ========================================================

    const { id } =
        useParams();


    // ========================================================
    // SIDEBAR
    // ========================================================

    const {
        setSidebar,
    } = useContext(
        SidebarContext
    );


    // ========================================================
    // STATE
    // ========================================================

    const [product, setProduct] =
        useState(
            DUMMY_PRODUCT
        );


    const [milestones, setMilestones] =
        useState(
            DUMMY_TIMELINE
        );


    const [visibleItems, setVisibleItems] =
        useState([]);


    const [loading, setLoading] =
        useState(false);


    const [error, setError] =
        useState(null);


    const timelineRef =
        useRef(null);


    // ========================================================
    // SIDEBAR COLLAPSE
    // ========================================================

    useEffect(() => {

        setSidebar(true);

    }, [
        setSidebar,
    ]);


    // ========================================================
    // FETCH API
    // ========================================================

    const fetchProductHistory =
        useCallback(
            async () => {

                // ---------------------------------------------
                // DUMMY MODE
                // ---------------------------------------------

                if (!USE_API) {

                    setProduct(
                        DUMMY_PRODUCT
                    );

                    setMilestones(
                        DUMMY_TIMELINE
                    );

                    setError(null);

                    setLoading(false);

                    return;

                }


                // ---------------------------------------------
                // API MODE
                // ---------------------------------------------

                setLoading(true);

                setError(null);


                try {

                    const response =
                        await axios.get(

                            `${API_URL}/product/history/${id}`,

                            {
                                headers: {

                                    Authorization:
                                        `Bearer ${localStorage.getItem(
                                            "authToken"
                                        )}`,

                                },

                            }

                        );


                    console.log(
                        "PRODUCT HISTORY:",
                        response.data
                    );


                    // -----------------------------------------
                    // API SUCCESS
                    // -----------------------------------------

                    if (
                        response.data?.success
                    ) {

                        const apiProduct =
                            response
                                .data
                                ?.data
                                ?.product;


                        const apiTimeline =
                            response
                                .data
                                ?.data
                                ?.timeline;


                        setProduct(
                            apiProduct ||
                            DUMMY_PRODUCT
                        );


                        setMilestones(
                            Array.isArray(
                                apiTimeline
                            )
                                ? apiTimeline
                                : []
                        );


                        setError(null);

                    }

                    else {

                        setError(
                            response
                                .data
                                ?.message ||
                            "Unable to load product history."
                        );

                    }

                }

                catch (err) {

                    console.error(
                        "PRODUCT HISTORY ERROR:",
                        err
                    );


                    /*
                    |--------------------------------------------------------------------------
                    | FALLBACK TO DUMMY DATA
                    |--------------------------------------------------------------------------
                    */

                    setProduct(
                        DUMMY_PRODUCT
                    );


                    setMilestones(
                        DUMMY_TIMELINE
                    );


                    setError(
                        err
                            ?.response
                            ?.data
                            ?.message ||
                        "Failed to load product history."
                    );

                }

                finally {

                    setLoading(false);

                }

            },

            [id]

        );


    // ========================================================
    // LOAD DATA
    // ========================================================

    useEffect(() => {

        fetchProductHistory();

    }, [
        fetchProductHistory,
    ]);


    // ========================================================
    // INTERSECTION OBSERVER
    // ========================================================

    useEffect(() => {

        if (
            !milestones.length
        ) {

            setVisibleItems([]);

            return;

        }


        const observer =
            new IntersectionObserver(

                (entries) => {

                    entries.forEach(
                        (entry) => {

                            const itemId =
                                entry
                                    .target
                                    .dataset
                                    .id;


                            if (
                                entry.isIntersecting
                            ) {

                                setVisibleItems(
                                    (prev) => {

                                        if (
                                            prev.includes(
                                                itemId
                                            )
                                        ) {

                                            return prev;

                                        }


                                        return [
                                            ...prev,
                                            itemId,
                                        ];

                                    }
                                );

                            }

                        }
                    );

                },

                {
                    threshold:
                        0.2,

                    rootMargin:
                        "0px 0px -50px 0px",
                }

            );


        const items =
            document.querySelectorAll(
                ".timeline-item"
            );


        items.forEach(
            (item) => {

                observer.observe(
                    item
                );

            }
        );


        return () => {

            observer.disconnect();

        };

    }, [
        milestones,
    ]);


    // ========================================================
    // LOADING
    // ========================================================

    if (loading) {

        return (

            <PageLayout>

                <div
                    className="text-center py-5"
                >

                    <Spinner
                        animation="border"
                    />

                    <p
                        className="mt-3 text-muted"
                    >
                        Loading product history...
                    </p>

                </div>

            </PageLayout>

        );

    }


    // ========================================================
    // PROGRESS
    // ========================================================

    const totalSteps =
        milestones.length;


    const completedSteps =
        milestones.length;


    const progressPercentage =
        totalSteps > 0
            ? Math.round(
                (
                    completedSteps /
                    totalSteps
                ) * 100
            )
            : 0;


    // ========================================================
    // RENDER
    // ========================================================

    return (

        <PageLayout>

            <div
                className="timeline-page"
            >


                {/* =====================================================
                    ERROR
                ====================================================== */}

                {error && USE_API && (

                    <Alert
                        variant="danger"
                        className="d-flex justify-content-between align-items-center"
                    >

                        <div>

                            <strong>
                                Error:
                            </strong>{" "}

                            {error}

                        </div>


                        <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={
                                fetchProductHistory
                            }
                        >
                            Retry
                        </Button>

                    </Alert>

                )}


                {/* =====================================================
                    PRODUCT
                ====================================================== */}

                {product && (

                    <Col xl={12}>

                        <Card
                            className="mb-4 shadow-sm"
                        >

                            <Card.Body>

                                <Row
                                    className="align-items-center"
                                >


                                    {/* =====================================
                                        PRODUCT IMAGE
                                    ====================================== */}

                                    <Col
                                        md={3}
                                        lg={2}
                                        className="mb-3 mb-md-0"
                                    >

                                        <div
                                            style={{
                                                height:
                                                    "150px",

                                                width:
                                                    "100%",

                                                background:
                                                    "#f8f9fa",

                                                borderRadius:
                                                    "10px",

                                                overflow:
                                                    "hidden",

                                                display:
                                                    "flex",

                                                alignItems:
                                                    "center",

                                                justifyContent:
                                                    "center",
                                            }}
                                        >

                                            {product
                                                ?.first_img ? (

                                                <img
                                                    src={
                                                        getImageUrl(
                                                            product.first_img
                                                        )
                                                    }
                                                    alt={
                                                        product.title ||
                                                        "Product"
                                                    }
                                                    style={{
                                                        width:
                                                            "100%",

                                                        height:
                                                            "100%",

                                                        objectFit:
                                                            "contain",
                                                    }}
                                                    onError={(
                                                        e
                                                    ) => {

                                                        e.currentTarget.style.display =
                                                            "none";

                                                    }}
                                                />

                                            ) : (

                                                <span
                                                    className="text-muted"
                                                >
                                                    No Image
                                                </span>

                                            )}

                                        </div>

                                    </Col>


                                    {/* =====================================
                                        PRODUCT DETAILS
                                    ====================================== */}

                                    <Col
                                        md={6}
                                        lg={7}
                                    >

                                        <small
                                            className="text-muted"
                                        >
                                            Product Code
                                        </small>


                                        <div
                                            className="mb-1"
                                        >

                                            <strong>
                                                {
                                                    product
                                                        ?.product_code ||
                                                    "N/A"
                                                }
                                            </strong>

                                        </div>


                                        <h4
                                            className="mb-2"
                                        >
                                            {
                                                product
                                                    ?.title ||
                                                "Untitled Product"
                                            }
                                        </h4>


                                        {product
                                            ?.brand && (

                                            <Badge
                                                bg="secondary"
                                                className="me-2"
                                            >
                                                Brand:{" "}
                                                {
                                                    product.brand
                                                }
                                            </Badge>

                                        )}


                                        {product
                                            ?.product_condition && (

                                            <Badge
                                                bg="info"
                                                className="me-2"
                                            >
                                                {
                                                    product.product_condition
                                                }
                                            </Badge>

                                        )}


                                        {product
                                            ?.short_description && (

                                            <p
                                                className="text-muted mt-2 mb-0"
                                            >
                                                {
                                                    product.short_description
                                                }
                                            </p>

                                        )}

                                    </Col>


                                    {/* =====================================
                                        PROGRESS
                                    ====================================== */}

                                    <Col
                                        md={3}
                                        lg={3}
                                        className="text-md-end mt-3 mt-md-0"
                                    >

                                        <small
                                            className="text-muted"
                                        >
                                            Workflow Progress
                                        </small>


                                        <h3
                                            className="mb-0"
                                        >

                                            {
                                                completedSteps
                                            }
                                            /
                                            {
                                                totalSteps
                                            }

                                        </h3>


                                        <small
                                            className="text-muted"
                                        >
                                            Steps completed
                                        </small>


                                        <div
                                            style={{
                                                marginTop:
                                                    "10px",

                                                height:
                                                    "7px",

                                                background:
                                                    "#e9ecef",

                                                borderRadius:
                                                    "10px",

                                                overflow:
                                                    "hidden",
                                            }}
                                        >

                                            <div
                                                style={{
                                                    width:
                                                        `${progressPercentage}%`,

                                                    height:
                                                        "100%",

                                                    background:
                                                        "#198754",

                                                    transition:
                                                        "width 0.3s ease",
                                                }}
                                            />

                                        </div>


                                        <small
                                            className="text-muted"
                                        >
                                            {
                                                progressPercentage
                                            }%
                                            completed
                                        </small>

                                    </Col>

                                </Row>


                                {/* =========================================
                                    USERS
                                ========================================== */}

                                <Row
                                    className="mt-4"
                                >

                                    <Col
                                        md={4}
                                        className="mb-2"
                                    >

                                        <div
                                            className="p-3"
                                            style={{
                                                background:
                                                    "#f8f9fa",

                                                borderRadius:
                                                    "8px",
                                            }}
                                        >

                                            <small
                                                className="text-muted d-block"
                                            >
                                                Issuer
                                            </small>

                                            <strong>
                                                {
                                                    product
                                                        ?.issuer ||
                                                    "N/A"
                                                }
                                            </strong>

                                        </div>

                                    </Col>


                                    <Col
                                        md={4}
                                        className="mb-2"
                                    >

                                        <div
                                            className="p-3"
                                            style={{
                                                background:
                                                    "#f8f9fa",

                                                borderRadius:
                                                    "8px",
                                            }}
                                        >

                                            <small
                                                className="text-muted d-block"
                                            >
                                                Lister
                                            </small>

                                            <strong>
                                                {
                                                    product
                                                        ?.lister ||
                                                    "N/A"
                                                }
                                            </strong>

                                        </div>

                                    </Col>


                                    <Col
                                        md={4}
                                        className="mb-2"
                                    >

                                        <div
                                            className="p-3"
                                            style={{
                                                background:
                                                    "#f8f9fa",

                                                borderRadius:
                                                    "8px",
                                            }}
                                        >

                                            <small
                                                className="text-muted d-block"
                                            >
                                                Checker
                                            </small>

                                            <strong>
                                                {
                                                    product
                                                        ?.checker ||
                                                    "Pending"
                                                }
                                            </strong>

                                        </div>

                                    </Col>

                                </Row>

                            </Card.Body>

                        </Card>

                    </Col>

                )}


                {/* =====================================================
                    TIMELINE
                ====================================================== */}

                <section
                    className="timeline-section"
                    ref={timelineRef}
                >

                    <div
                        className="timeline-container"
                    >

                        <div
                            className="timeline-line"
                        >

                            <div
                                className="timeline-progress"
                                style={{
                                    height:
                                        `${progressPercentage}%`,
                                }}
                            />

                        </div>


                        {/* =============================================
                            TIMELINE ITEMS
                        ============================================== */}

                        {milestones.map(
                            (
                                item,
                                index
                            ) => {

                                const itemId =
                                    String(
                                        index + 1
                                    );


                                const isVisible =
                                    visibleItems.includes(
                                        itemId
                                    );


                                const isEven =
                                    index % 2 === 0;


                                const event =
                                    item?.event ||
                                    "Product Movement";


                                const category =
                                    getEventCategory(
                                        event
                                    );


                                return (

                                    <div
                                        key={
                                            `${index}-${event}`
                                        }
                                        className={
                                            `timeline-item ${
                                                isEven
                                                    ? "left"
                                                    : "right"
                                            } ${
                                                isVisible
                                                    ? "visible"
                                                    : ""
                                            }`
                                        }
                                        data-id={
                                            itemId
                                        }
                                    >


                                        {/* =================================
                                            DOT
                                        ================================== */}

                                        <div
                                            className="timeline-dot-wrapper"
                                        >

                                            <div
                                                className={
                                                    `timeline-dot ${
                                                        isVisible
                                                            ? "pulse"
                                                            : ""
                                                    }`
                                                }
                                            >

                                                <span
                                                    className="dot-icon"
                                                >
                                                    {
                                                        getEventIcon(
                                                            event
                                                        )
                                                    }
                                                </span>

                                            </div>

                                        </div>


                                        {/* =================================
                                            CARD
                                        ================================== */}

                                        <div
                                            className="timeline-card"
                                        >

                                            <div
                                                className="card-glow"
                                            />


                                            <div
                                                className="card-content"
                                            >


                                                {/* =============================
                                                    HEADER
                                                ============================== */}

                                                <div
                                                    className="card-header"
                                                >

                                                    <span
                                                        className="card-category"
                                                    >
                                                        {
                                                            category
                                                        }
                                                    </span>


                                                    <span
                                                        className="card-date"
                                                    >
                                                        {
                                                            item?.date ||
                                                            ""
                                                        }
                                                    </span>

                                                </div>


                                                {/* =============================
                                                    TITLE
                                                ============================== */}

                                                <h3
                                                    className="card-title"
                                                >
                                                    {
                                                        event
                                                    }
                                                </h3>


                                                {/* =============================
                                                    DESCRIPTION
                                                ============================== */}

                                                <p
                                                    className="card-description"
                                                >

                                                    Product movement
                                                    recorded successfully.

                                                </p>


                                                {/* =============================
                                                    FOOTER
                                                ============================== */}

                                                <div
                                                    className="card-footer"
                                                >

                                                    <div
                                                        className="card-footer-left"
                                                    >

                                                        <span
                                                            className="card-index"
                                                        >
                                                            #
                                                            {
                                                                String(
                                                                    index +
                                                                    1
                                                                ).padStart(
                                                                    2,
                                                                    "0"
                                                                )
                                                            }
                                                        </span>


                                                        {item
                                                            ?.image && (

                                                            <img
                                                                src={
                                                                    getImageUrl(
                                                                        item.image
                                                                    )
                                                                }
                                                                alt={
                                                                    event
                                                                }
                                                                className="card-image-circle"
                                                                onError={(
                                                                    e
                                                                ) => {

                                                                    e.currentTarget.style.display =
                                                                        "none";

                                                                }}
                                                            />

                                                        )}

                                                    </div>


                                                    <div
                                                        className="card-arrow"
                                                    >

                                                        <svg
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                        >

                                                            <path d="M5 12h14M12 5l7 7-7 7" />

                                                        </svg>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                );

                            }
                        )}

                    </div>


                    {/* =====================================================
                        EMPTY TIMELINE
                    ====================================================== */}

                    {milestones.length === 0 && (

                        <div
                            className="text-center py-5"
                        >

                            <p
                                className="text-muted"
                            >
                                No product movement
                                history found.
                            </p>

                        </div>

                    )}


                    {/* =====================================================
                        BOTTOM CTA
                    ====================================================== */}

                    <div
                        className="timeline-cta"
                    >

                        <p
                            className="cta-text"
                        >
                            Product movement history complete
                        </p>


                        <button
                            className="cta-button"
                        >

                            <span>
                                {
                                    completedSteps
                                }{" "}
                                Movements
                            </span>


                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                            >

                                <path d="M5 12h14M12 5l7 7-7 7" />

                            </svg>

                        </button>

                    </div>

                </section>

            </div>

        </PageLayout>

    );

};


export default Timeline;